// extracted by mini-css-extract-plugin
export default {"link":"NumberSwitcher_link__wMgm5","active":"NumberSwitcher_active__eG1KA","placeHolderShimmer":"NumberSwitcher_placeHolderShimmer__EkbTN"};